const CardRegisterDate = ({ date, expand }) => {
  return (
    <div className="card__registerDate">
      <h3>Data Cadastro{expand && ':'}</h3>
      <p>{new Date(date).toLocaleDateString()}</p>
    </div>
  );
};

export default CardRegisterDate;
